import { BASE_URL } from '@helpers/constants'
import setAuthorization from '@helpers/setAuthorization'
import {
	RecurrentJuriesResponse,
	RecurrentQuestionsRequest,
	RecurrentQuestionsResponse,
	RecurrentYearsResponse,
} from '@models/recurrentQuestions.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const reportApi = createApi({
	reducerPath: 'reportApi',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) =>
			setAuthorization(headers, { getState, endpoint }),
	}),
	endpoints: (builder) => ({
		getRecurrentJuries: builder.query<RecurrentJuriesResponse, void>({
			query: () => ({
				url: '/recurrent-questions/juries',
				method: 'GET',
			}),
		}),

		getRecurrentYears: builder.query<RecurrentYearsResponse, void>({
			query: () => ({
				url: '/recurrent-questions/year',
				method: 'GET',
			}),
		}),

		getRecurrentQuestions: builder.mutation<
			RecurrentQuestionsResponse,
			RecurrentQuestionsRequest
		>({
			query: ({ disciplineId, juryId, yearId, page = 1, search }) => {
				let queryUrl = `/recurrent-questions?disciplineId=${disciplineId}`

				if (juryId) queryUrl += `&juryId=${juryId}`
				if (yearId) queryUrl += `&yearId=${yearId}`

				if (search) queryUrl += `&search=${encodeURIComponent(search)}`

				queryUrl += `&page=${page}`

				return {
					url: queryUrl,
					method: 'GET',
				}
			},
		}),
	}),
})

export const {
	useGetRecurrentJuriesQuery,
	useGetRecurrentYearsQuery,
	useGetRecurrentQuestionsMutation,
} = reportApi
